import React, {useState, useEffect } from "react";
import { toImageUrl } from "../../config";
import { getCategoriesByID, DeletePub } from "../auth/apiCategory";
import { isAuthenticated } from '../auth';
import ChoosePub from "./Choosepub";
import imgLakay from '../Layout/imgs/Untitled-2.jpg';
import imgProductLakay from '../Layout/imgs/md3.jpg'
import PuB1500 from './Pub1500X500'
import PuB500 from './PubR400x400'
import PuB400 from './PubC400X400'
import CategorySelector from "./Categoryselector";
import PubGallery from "./Pubgallery";
import { FaDesktop, FaMobileAlt, FaImages } from "react-icons/fa";
import { MdEdit, MdLibraryAdd } from "react-icons/md";
import "./Uploadpages.css"
import "./PubUploadForm.css"
import CategoryBannerSwiperPanel from "../dynamicSwipers/CategoryBannerSwiperPanel";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addPubGloabal"]?.[key] || fallback;

const filterObject = (data, include = [], exclude = []) =>{
  // Si include et exclude sont vides → retourne tout
  if (include?.length === 0 && exclude?.length === 0) {
    return { ...data };

  }

  let result = {};

  if (include?.length > 0) {
    // Garder uniquement les clés incluses
    include.forEach(key => {
      if (key in data) {
        result[key] = data[key];
      }
    });
  } else {
    // Copier tout
    result = { ...data };
  }

  if (exclude?.length > 0) {
    // Supprimer les clés exclues
    exclude.forEach(key => {
      delete result[key];
    });
  }

  return result; 
}


const AddPubGloabal = props => {
    const {
        laguangeElakay,
        infoSource
        } = props
    __setElakayInfoSource(infoSource);
    const [getSize, setSize] = useState('d');
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState({});
    const [getpub, setPub] = useState([]);
    const [getpubC, setPubC] = useState([]);
    const [getpubR, setPubR] = useState([]);
    const [catSelectedSearch, setcatSelectedSearch] = useState(false);
    // const [loading, setLoading] = useState(true);
    const [elakayCategoryID, setElakayCategoryID] = useState('5ed4946fd2ba8812c20261a8');
   
    const [imagePubID, setImagePubID] = useState(null);
    const [imgEdit, setEmgEdit] = useState(undefined);
    const { token } = isAuthenticated();
    const [pubShowNav, setPubShowNav] = useState({
        showPuB1500X400FT: false,
        showPuB500X500FT:false,
        showPuB400X400FT:false
    })

    const {
        showPuB1500X400FT,
        showPuB500X500FT,
        showPuB400X400FT
    } = pubShowNav

  


    const loadCategory = async (ID) => {
         setElakayCategoryID(ID)
                try {
                      const encryptedData = await getCategoriesByID(ID);
                      const data = encryptedData;
                         if (data.error) {
                            throw new Error(data.error)
                            } else {
                            setCategory(filterObject(data.cartegory, [], ["items"]))
                            setCategories(data.cartegory)
                            setPub(data.pub)
                            setPubR(data.image_r)
                            setPubC(data.image_c)
                            // setLoading(false)
                        }
                   } catch (err) {
            console.error("Erreur lors du chargement de l'utilisateur :", err);
          }
    };

    useEffect(() => {
        loadCategory(elakayCategoryID)
    }, []);


    const loadSelectCategory = (obj) => {
      setCategory(filterObject(obj, [], ["items"]))
       setElakayCategoryID(obj._id)
        setPub(obj.pub)
        setPubR(obj.image_r)
        setPubC(obj.image_c)
    }

    const ButtonPuB1500X400 = (img = false) => {
       img && setImagePubID(null)
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: true,
            showPuB500X500FT: false,
            showPuB400X400FT: false,
            shooseTypeOfPubFT: false,
        })
    };

    const ButtonPuB500X500 = () => {
        setImagePubID(null)
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: false,
            showPuB500X500FT: true,
            showPuB400X400FT: false,
            shooseTypeOfPubFT: false,
        })
    };
    const ButtonPuB400X400 = () => {
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: false,
            showPuB500X500FT: false,
            showPuB400X400FT: true,
            shooseTypeOfPubFT: false,
        })
    };

    const ButtonCancel = () => {
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: false,
            showPuB500X500FT: false,
            showPuB400X400FT: false,
            shooseTypeOfPubFT: true,
        })
    };
    const ImageSizeSelector = () => {
  return (
    <div className="pub-size-selector">
      <label
        onClick={() => setSize("d")}
        className={`pub-size-badge pub-size-badge--desktop ${getSize === "d" ? "is-active" : ""}`}
      >
        <input
          type="radio"
          name="imageSize"
          value="d"
          checked={getSize === "d"}
          onChange={() => setSize("d")}
          style={{ display: "none" }}
        />
        <FaDesktop />{__elakayText("t001", "Desktop & Tablet")}</label>

      <label
        onClick={() => setSize("m")}
        className={`pub-size-badge pub-size-badge--mobile ${getSize === "m" ? "is-active" : ""}`}
      >
        <input
          type="radio"
          name="imageSize"
          value="m"
          checked={getSize === "m"}
          onChange={() => setSize("m")}
          style={{ display: "none" }}
        />
        <FaMobileAlt />{__elakayText("t003", "Mobile")}</label>

      <label
        onClick={() => setSize("m")}
        className="pub-action-btn"
        style={{ padding: !imagePubID ? "10px 20px" : "10px 5px" }}
      >
        <input
          type="radio"
          name="imageSize"
          value="m"
          style={{ display: "none" }}
        />
       {!imagePubID?
        <MdLibraryAdd />
        :
        <MdEdit/>}
        {imagePubID && <img
                            src={toImageUrl(imgEdit)}
                            alt={imgEdit}
                            style={{width: "70px" }}
                        />}
      </label>
    </div>
  );
};

  const showPub1500 =()=>(
      showPuB1500X400FT && (
        <>
       
          <PuB1500
              elakayCategoryID={elakayCategoryID}
              categories_ID={categories._id}
              loadCategory={loadCategory}
              ButtonCancel={ButtonCancel}
              laguangeElakay={laguangeElakay}
              infoSource={infoSource}
              getSize={getSize} 
              setSize={setSize}
              imagePubID={imagePubID}
              ImageSizeSelector={ImageSizeSelector}
          /></>
      )
  )
    const showPuB500 = () => (
        showPuB500X500FT && (
     
            <PuB500
                elakayCategoryID={elakayCategoryID}
                 categories_ID={categories._id}
                loadCategory={loadCategory}
                ButtonCancel={ButtonCancel}
                laguangeElakay={laguangeElakay}
                infoSource={infoSource}
                getSize={getSize} 
                setSize={setSize}
                ImageSizeSelector={ImageSizeSelector}
            />
      )
    )

    const showPuB400= () => (
        showPuB400X400FT && (
            <PuB400 
                elakayCategoryID={elakayCategoryID}
                 categories_ID={categories._id}
                loadCategory={loadCategory}
                ButtonCancel={ButtonCancel}
                laguangeElakay={laguangeElakay}
                infoSource={infoSource}
            />
      )
    )

    const deleteImage = (categoryID, pubID, pub) => {
        DeletePub(token, categoryID, pubID, pub).then(data => {
            if (data.error) {
            } else {
            
                loadCategory(categories._id)
            }
        });
    };

  
    return (
        <div className="pub-global-page">
        <div>
            <h2 className="pub-global-page-title">
                <FaImages /> {__elakayText("t004", "Gestion des publicités")}
            </h2>
            <p className="pub-global-page-subtitle">
                {__elakayText("t005", "Choisissez une catégorie, ajoutez vos visuels publicitaires et gérez votre galerie.")}
            </p>
        </div>

        {/* {shoosingSelectCategory(categories)} */}
    <CategorySelector
  categories={categories}
  elakayCategoryID={elakayCategoryID}
  catSelectedSearch={catSelectedSearch}
  setcatSelectedSearch={setcatSelectedSearch}
  loadCategory={loadCategory}
  loadSelectCategory={loadSelectCategory}
  infoSource={infoSource}
  filterObject={filterObject}
  setCategory={setCategory}
  setElakayCategoryID={setElakayCategoryID}
  setPub={setPub}
  setPubR={setPubR}
  setPubC={setPubC}
/>
        {/* Advertising Content: existing images (below) or an Elakay Swiper. */}
        <CategoryBannerSwiperPanel
            categoryId={elakayCategoryID}
            categoryName={Array.isArray(category?.name) ? category.name[0] : (category?.name || "")}
        />
        <ChoosePub 
    imgLakay={imgLakay}
    imgProductLakay={imgProductLakay}
    elakayCategoryID={elakayCategoryID}
    infoSource={infoSource}
    ButtonPuB1500X400={ButtonPuB1500X400}
    ButtonPuB500X500={ButtonPuB500X500}
    ButtonPuB400X400={ButtonPuB400X400}
/>
        {showPub1500()}
        {showPuB500()}
        {showPuB400()}
        <div className="pub-section-card">
        <PubGallery
    category={category}
    getpub={getpub}
    getpubR={getpubR}
    getpubC={getpubC}
    elakayCategoryID={elakayCategoryID}
    imagePubID={imagePubID}
    infoSource={infoSource}
    toImageUrl={toImageUrl}
    imgLakay={imgLakay}
    imgProductLakay={imgProductLakay}
    deleteImage={deleteImage}
    setImagePubID={setImagePubID}
    ButtonPuB1500X400={ButtonPuB1500X400}
    ButtonCancel={ButtonCancel}
    setEmgEdit={setEmgEdit}
/>
        </div>
        </div>
    )
};

export default AddPubGloabal;